import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from "./ReportStyle";

const WastageReport = (apiData) => {

  const data = apiData && !Array.isArray(apiData)
    ? apiData
    : apiData?.[0];

  if (!data) return;

  const doc = new jsPDF('p', 'pt', 'a4'); // ✅ A4 ONLY

  style.pageHeder(doc, data);
  style.reportHeder1(doc, data);
  style.tableBody(doc, data);
  style.pageFooter(doc, data);

  const pdfUrl = URL.createObjectURL(doc.output('blob'));
  window.open(pdfUrl);
};

export default WastageReport;
